<template>
  <a :download="download" :href="href" target="_blank" />
</template>

<script>
export default {
  name: "SjDownload",
  data() {
    return {
      href: null,
      download: null
    };
  },
  mounted() {
    this.$el.click();
    this.$nextTick(() => {
      // this.destroyElement();
    });
  },
  methods: {
    destroyElement() {
      this.$destroy(true);
      this.$el.parentNode.removeChild(this.$el);
    }
  }
};
</script>
